import './polyfils/node_list_for_each'
import './polyfils/element_closest'

import { airbrake } from './common/airbrake'
import { loadPhones } from './js/load_phones'
import { bindForms, trackLead } from './js/bind_forms'
import { prepareModal } from './js/modals'
import { debugLog } from './common/utils'

let startApp = () => {
  prepareModal()
  bindForms()
  loadPhones()
}

startApp = airbrake.wrap(startApp)
startApp()

window.Jensen = {
  trackLead: trackLead
}

debugLog('jensen script v1.0 loaded')



// WEBPACK FOOTER //
// ./app/index.js